import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import AccountService from "./AccountService";
import AccountCardGrid from "./AccountCardGrid";
import { getColumns } from "./getColumns";

export default function AccountList({
    keyword,
    testAccountFilter = "exclude",
    excludeStaffUser = false,
    excludeAppleStaff = false,
    appCode = "",
    variant = "table",
    pageModel,
    onPageModelChange,
    sort,
    onSortChange,
}) {
    const navigate = useNavigate();

    const [rowCount, setRowCount] = useState(0);
    const [rows, setRows] = useState([]);

    useEffect(() => {
        AccountService.requestUser(
            keyword,
            pageModel.page,
            pageModel.pageSize,
            sort,
            setRows,
            setRowCount,
            testAccountFilter,
            excludeStaffUser,
            excludeAppleStaff,
            appCode,
        );
    }, [keyword, pageModel, sort, testAccountFilter, excludeStaffUser, excludeAppleStaff, appCode]);

    const handleCell = () => {
        // no-op
    };

    const handleSelectionModel = () => {
        // do something
    };

    return (
        <Box sx={{ flexGrow: 1, height: variant === "cards" ? "auto" : "50%" }}>
            {variant === "cards" ? (
                <AccountCardGrid
                    rows={rows}
                    rowCount={rowCount}
                    pageModel={pageModel}
                    onPageModelChange={onPageModelChange}
                />
            ) : (
                <DataGrid
                rows={rows}
                columns={getColumns(navigate)}
                rowCount={rowCount}
                paginationModel={pageModel}
                onPaginationModelChange={(m) => onPageModelChange(m)}
                checkboxSelection
                disableSelectionOnClick
                experimentalFeatures={{ newEditingApi: true }}
                paginationMode={"server"}
                sortingMode="server"
                sortModel={sort}
                pageSizeOptions={[25, 50, 100]}
                onCellClick={handleCell}
                onSortModelChange={(model) => onSortChange(model)}
                onSelectionModelChange={handleSelectionModel}
                columnVisibilityModel={{ id: false }}
                autoHeight={true}
                getRowHeight={() => "auto"}
                sx={{
                    "& .MuiDataGrid-cell": {
                        py: 1,
                        display: "flex",
                        alignItems: "center",
                    },
                }}
                hideFooterSelectedRowCount
                initialState={{
                    columns: {
                        columnVisibilityModel: {
                            id: false,
                        },
                    },
                }}
                />
            )}
        </Box>
    );
}
